import React from 'react';
import { Button } from '@nextui-org/react';
import Render from '../../../../components/render';
import TabScale from './tab-scale';
import TabIndicators from './tab-indicators';

const TAB = {
  SCALE: 1,
  INDICATORS: 2,
}

const SettingsScales = () => {
  const [tab, setTab] = React.useState(TAB.SCALE);

  return (
    <div className="flex flex-col items-center">
      <div className="flex gap-4">
        <Button
          className="text-white font-semibold whitespace-pre h-14 bg-blue data-[active=true]:bg-green"
          data-active={String(tab === TAB.SCALE)}
          onPress={() => setTab(TAB.SCALE)}
        >
          Escala de calificaciones
        </Button>

        <Button
          className="text-white font-semibold whitespace-pre h-14 bg-blue data-[active=true]:bg-green"
          data-active={String(tab === TAB.INDICATORS)}
          onPress={() => setTab(TAB.INDICATORS)}
        >
          Indicadores de evaluación{'\n'}por materia
        </Button>
      </div>

      <Render condition={tab === TAB.SCALE}>
        <TabScale />
      </Render>

      <Render condition={tab === TAB.INDICATORS}>
        <TabIndicators />
      </Render>
    </div>
  );
}

export default SettingsScales